import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Typography,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import "../styles/BlogList.css";

const BLOGS_API = process.env.REACT_APP_BLOGS_API_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await fetch(BLOGS_API);
      const data = await res.json();

      console.log("Fetched blogs:", data); // Debug log

      if (data.success) {
        setBlogs(data.blogs);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ IMPROVED SLUG GENERATION
  const createSlug = (title) => {
    if (!title || typeof title !== 'string' || title.trim() === '') {
      console.error('Invalid title for slug:', title);
      return null;
    }

    const slug = title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special characters except spaces and hyphens
      .replace(/\s+/g, '-')      // Replace spaces with hyphens
      .replace(/-+/g, '-')       // Replace multiple hyphens with single hyphen
      .replace(/^-+|-+$/g, '');  // Remove leading/trailing hyphens

    return slug;
  };

  const handleReadMore = (blog) => {
    console.log('Blog object:', blog); // Debug log
    console.log('Blog title:', blog.title); // Debug log

    const slug = createSlug(blog.title);
    
    console.log('Generated slug:', slug); // Debug log

    if (!slug) {
      console.error('Failed to generate slug');
      return;
    }

    navigate(`/blog/${slug}`);
  };

  // ================= LOADING =================
  if (loading) {
    return (
      <Box className="loading-container" sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <div className="blog-page">
      <Container maxWidth="lg" className="blog-container" sx={{ py: 5 }}>
        <Box className="blog-header" sx={{ mb: 5, textAlign: 'center' }}>
          <Typography variant="h2" component="h1" className="blog-title" sx={{ mb: 2 }}>
            Our Blog
          </Typography>
          <Typography variant="h6" className="blog-subtitle" color="white">
            Discover our latest articles and insights
          </Typography>
        </Box>

        {blogs.length === 0 ? (
          <Box className="empty-state" sx={{ 
            textAlign: 'center', 
            py: 8 
          }}>
            <Typography variant="h5">No blogs available yet.</Typography>
          </Box>
        ) : (
          <Grid container spacing={4}>
            {blogs.map((blog) => (
              <Grid item xs={12} sm={6} md={4} key={blog.id}>
                <Card className="blog-card" sx={{ 
                  height: '100%', 
                  display: 'flex', 
                  flexDirection: 'column' 
                }}>
                  <CardMedia
                    component="img"
                    height="240"
                    image={`${BASE_URL}/uploads/${blog.image}`}
                    alt={blog.title || 'Blog image'}
                    sx={{ objectFit: 'cover' }}
                  />

                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {blog.title}
                    </Typography>

                    {/* ✅ EXCERPT FROM DOCUMENT */}
                    {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {(blog.document || "No content available")
                        .split(" ")
                        .slice(0, 20)
                        .join(" ")}
                      {blog.document && blog.document.split(" ").length > 20 ? "..." : ""}
                    </Typography> */}

                    <Typography variant="caption" color="text.secondary">
                      {new Date(blog.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </Typography>
                  </CardContent>

                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => handleReadMore(blog)}
                    >
                      Read More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </div>
  );
};

export default BlogList;